import React, { useEffect, useState } from "react";
import {
  Grid,
  Typography,
  Chip,
  Button,
  Avatar,
  Stack,
  Paper,
  Box,
} from "@mui/material";
import {
  LocationOn as LocationIcon,
  Email as EmailIcon,
  Phone as PhoneIcon,
  GitHub as GitHubIcon,
  LinkedIn as LinkedInIcon,
} from "@mui/icons-material";
import Subin from "../assests/subinPhoto.jpg";

const stats = [
  { label: "GPA", value: "4.0", icon: "🎓" },
  { label: "Graduation", value: "May '26", icon: "📅" },
  { label: "Awards", value: "7+", icon: "🏆" },
  { label: "Internships", value: "3+", icon: "💼" },
];

export const HeroSection = () => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => setVisible(true), 80);
    return () => clearTimeout(timer);
  }, []);

  return (
    <Paper
      elevation={0}
      sx={{
        mb: 4,
        borderRadius: 4,
        overflow: "hidden",
        border: "1px solid var(--border-color)",
        background: "var(--card-bg)",
        boxShadow: "0 8px 32px rgba(102, 126, 234, 0.12)",
        opacity: visible ? 1 : 0,
        transform: visible ? "translateY(0)" : "translateY(20px)",
        transition: "opacity 0.6s ease-out, transform 0.6s ease-out",
      }}
    >
      {/* Gradient Banner */}
      <Box
        sx={{
          background: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
          height: { xs: 90, md: 110 },
          position: "relative",
          overflow: "hidden",
          "&::before": {
            content: '""',
            position: "absolute",
            top: "-50%",
            right: "-10%",
            width: "300px",
            height: "300px",
            borderRadius: "50%",
            background: "rgba(255,255,255,0.08)",
          },
          "&::after": {
            content: '""',
            position: "absolute",
            bottom: "-30%",
            left: "15%",
            width: "200px",
            height: "200px",
            borderRadius: "50%",
            background: "rgba(255,255,255,0.05)",
          },
        }}
      />

      {/* Main Content */}
      <Box sx={{ px: { xs: 3, md: 5 }, pb: 4, background: "var(--card-bg)" }}>
        <Grid container spacing={3} alignItems="flex-start">
          {/* Avatar */}
          <Grid
            item
            xs={12}
            md={2}
            sx={{ textAlign: { xs: "center", md: "left" } }}
          >
            <Box
              sx={{
                display: "inline-block",
                mt: "-55px",
                position: "relative",
                borderRadius: "50%",
                p: "3px",
                background:
                  "linear-gradient(135deg, #667eea 0%, #f093fb 50%, #764ba2 100%)",
                boxShadow: "0 8px 28px rgba(102, 126, 234, 0.45)",
                animation: "pulse 3s infinite ease-in-out",
              }}
            >
              <Avatar
                src={Subin}
                sx={{
                  width: { xs: 120, md: 135 },
                  height: { xs: 120, md: 135 },
                  border: "4px solid var(--card-bg)",
                  display: "block",
                }}
              />
            </Box>
          </Grid>

          {/* Info */}
          <Grid item xs={12} md={10} sx={{ pt: { md: 1.5 } }}>
            <Typography
              variant="h3"
              fontWeight="800"
              sx={{
                color: "var(--body_color)",
                fontSize: { xs: "2rem", md: "2.6rem" },
                letterSpacing: "-0.02em",
                lineHeight: 1.1,
                animation: "fadeInDown 0.6s ease-out",
              }}
            >
              Subin Bista
            </Typography>

            <Typography
              variant="h6"
              sx={{
                fontWeight: 600,
                mb: 1.5,
                fontSize: { xs: "1rem", md: "1.1rem" },
                animation: "fadeInDown 0.75s ease-out",
                background:
                  "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
                WebkitBackgroundClip: "text",
                WebkitTextFillColor: "transparent",
                backgroundClip: "text",
              }}
            >
              Full-Stack Developer &nbsp;|&nbsp; Computer Science @ SELU
              &nbsp;|&nbsp; GPA 4.0
            </Typography>

            <Stack
              direction="row"
              spacing={1}
              flexWrap="wrap"
              sx={{ mb: 2, gap: 0.8 }}
            >
              {[
                {
                  icon: <LocationIcon sx={{ fontSize: 14 }} />,
                  label: "Hammond, LA",
                },
                {
                  icon: <EmailIcon sx={{ fontSize: 14 }} />,
                  label: "subinbista222@gmail.com",
                },
                {
                  icon: <PhoneIcon sx={{ fontSize: 14 }} />,
                  label: "225-441-0921",
                },
              ].map((item, i) => (
                <Chip
                  key={i}
                  icon={item.icon}
                  label={item.label}
                  size="small"
                  sx={{
                    bgcolor: "rgba(102,126,234,0.1)",
                    color: "var(--body_color)",
                    border: "1px solid rgba(102,126,234,0.2)",
                    fontWeight: 500,
                    fontSize: "0.78rem",
                    "& .MuiChip-icon": { color: "#667eea" },
                    transition: "all 0.2s ease",
                    "&:hover": {
                      bgcolor: "rgba(102,126,234,0.18)",
                      transform: "translateY(-1px)",
                    },
                  }}
                />
              ))}
            </Stack>

            <Typography
              variant="body1"
              sx={{
                mb: 2.5,
                lineHeight: 1.75,
                color: "var(--body_color)",
                opacity: 0.88,
                maxWidth: 700,
                fontSize: "0.97rem",
              }}
            >
              Enthusiastic Computer Science student aiming to leverage expertise
              in software development, data science, and AI to build innovative
              solutions with meaningful societal impact — from disaster
              management and AI-powered geospatial tools to digital preservation
              projects.
            </Typography>

            <Stack
              direction="row"
              spacing={1.5}
              flexWrap="wrap"
              sx={{ gap: 1 }}
            >
              <Button
                variant="contained"
                startIcon={<GitHubIcon />}
                size="small"
                href="https://github.com/Subeen9"
                target="_blank"
                rel="noopener noreferrer"
                sx={{
                  bgcolor: "#24292e",
                  textTransform: "none",
                  fontWeight: 600,
                  borderRadius: 2,
                  px: 2,
                  "&:hover": {
                    bgcolor: "#1a1f23",
                    transform: "translateY(-2px)",
                    boxShadow: "0 6px 16px rgba(0,0,0,0.25)",
                  },
                  transition: "all 0.2s ease",
                }}
              >
                GitHub
              </Button>
              <Button
                variant="contained"
                startIcon={<LinkedInIcon />}
                size="small"
                href="https://www.linkedin.com/in/subin-bista-/"
                target="_blank"
                rel="noopener noreferrer"
                sx={{
                  bgcolor: "#0077b5",
                  textTransform: "none",
                  fontWeight: 600,
                  borderRadius: 2,
                  px: 2,
                  "&:hover": {
                    bgcolor: "#005e8f",
                    transform: "translateY(-2px)",
                    boxShadow: "0 6px 16px rgba(0,119,181,0.35)",
                  },
                  transition: "all 0.2s ease",
                }}
              >
                LinkedIn
              </Button>
            </Stack>
          </Grid>
        </Grid>

        {/* Stats Row */}
        <Grid container spacing={2} sx={{ mt: 3 }}>
          {stats.map((stat, i) => (
            <Grid item xs={6} sm={3} key={i}>
              <Box
                sx={{
                  textAlign: "center",
                  p: { xs: 1.5, md: 2 },
                  borderRadius: 3,
                  background:
                    "linear-gradient(135deg, rgba(102,126,234,0.07) 0%, rgba(118,75,162,0.07) 100%)",
                  border: "1px solid rgba(102,126,234,0.15)",
                  cursor: "default",
                  transition: "all 0.3s ease",
                  "&:hover": {
                    transform: "translateY(-5px)",
                    boxShadow: "0 10px 24px rgba(102,126,234,0.18)",
                    background:
                      "linear-gradient(135deg, rgba(102,126,234,0.14) 0%, rgba(118,75,162,0.14) 100%)",
                    border: "1px solid rgba(102,126,234,0.3)",
                  },
                }}
              >
                <Typography sx={{ fontSize: "1.4rem", mb: 0.3 }}>
                  {stat.icon}
                </Typography>
                <Typography
                  variant="h5"
                  fontWeight="800"
                  sx={{
                    background:
                      "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
                    WebkitBackgroundClip: "text",
                    WebkitTextFillColor: "transparent",
                    backgroundClip: "text",
                    lineHeight: 1.2,
                    fontSize: { xs: "1.3rem", md: "1.5rem" },
                  }}
                >
                  {stat.value}
                </Typography>
                <Typography
                  variant="caption"
                  sx={{
                    color: "var(--body_color)",
                    opacity: 0.65,
                    fontWeight: 600,
                    textTransform: "uppercase",
                    letterSpacing: 0.5,
                    fontSize: "0.68rem",
                  }}
                >
                  {stat.label}
                </Typography>
              </Box>
            </Grid>
          ))}
        </Grid>
      </Box>
    </Paper>
  );
};
